var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "inputContainer",
      class: [_vm.invalidClass, _vm.isDisabled],
    },
    [
      _vm._t("prefix", function () {
        return [
          _c("span", { staticClass: "text-gray-700 self-center" }, [
            _vm._v(" " + _vm._s(_vm.prefix) + " "),
          ]),
        ]
      }),
      _c("TheMask", {
        staticClass: "inputClass",
        attrs: {
          value: _vm.value,
          placeholder: "###############",
          mask: "################",
          disabled: _vm.disabled,
        },
        on: { input: _vm.handleInput },
        nativeOn: {
          change: function ($event) {
            return _vm.handleChange.apply(null, arguments)
          },
          focus: function ($event) {
            return _vm.handleFocus.apply(null, arguments)
          },
          blur: function ($event) {
            return _vm.handleBlur.apply(null, arguments)
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }